import { createSlice } from "@reduxjs/toolkit";
import axios from "utils/axios";
import { dispatch } from "../index";
import { storage } from "../../utils/helpers/storage";
import { getDashboardsByAccess } from "../../utils/helpers/permissions";

// ----------------------------------------------------------------------

export const initialState = {
  error: null,
  availableDashboards: [],
  analyticsCategory: "",
  analyticsSection: "",
  dashboards: [],
  selectedDashboard: storage.getSelectedDashboard()
    ? JSON.parse(storage.getSelectedDashboard())
    : null,
};

const slice = createSlice({
  name: "analytics",
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = action.payload;
    },

    getDashboardsSuccess(state, action) {
      state.dashboards = action.payload;
    },

    setAvailableDashboards(state, action) {
      state.availableDashboards = action.payload;
    },
    setAnalyticsCategory(state, action) {
      state.analyticsCategory = action.payload;
    },
    setAnalyticsSection(state, action) {
      state.analyticsSection = action.payload;
    },

    setSelectedDashboard(state, action) {
      storage.setSelectedDashboard(JSON.stringify(action.payload) || null);
      state.selectedDashboard = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getDashboards(
  analyticsCategory,
  analyticsSection,
  selectedSite
) {
  return async () => {
    try {
      let filters = analyticsCategory ? `?category=${analyticsCategory}` : "";
      const response = await axios.get(
        `${process.env.REACT_APP_API}/analytics/analytics/dashboard${filters}`,
        {},
        {}
      );

      let _availableDashboards = [];

      if (selectedSite?.id && response?.data?.count > 0) {
        _availableDashboards = getDashboardsByAccess(
          response?.data,
          analyticsSection,
          selectedSite
        );
        dispatch(slice.actions.setAnalyticsSection(analyticsSection));
      }

      dispatch(slice.actions.setAnalyticsCategory(analyticsCategory));
      dispatch(slice.actions.setAvailableDashboards(_availableDashboards));
      dispatch(slice.actions.getDashboardsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getReportUrl(data) {
  return async () => {
    try {
      return await axios.get(
        `${process.env.REACT_APP_API}/analytics/analytics/report/${data.reportId}`,
        {
          headers: {
            "Content-Type": "application/json",
            "locus-powerbi": data.powerBi,
            "locus-user": `{"username":"${data.userName}"}`,
            "locus-dataset-id": data.datasetId,
            "locus-warehouse": data.condensedName,
            "locus-client-id": data.clientId,
          },
        }
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return error;
    }
  };
}

export function createDashboard(data) {
  return async () => {
    try {
      return data;
      // return axios.post(
      //     `${process.env.REACT_APP_SERVICES_API}/analytics/dashboard`,
      //     data,
      //     {}
      // );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return error;
    }
  };
}

export function setSelectedDashboard(dashboard) {
  return async () => {
    try {
      dispatch(slice.actions.setSelectedDashboard(dashboard));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
